import { gql, useQuery } from '@apollo/client';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React from 'react';

import { Loading } from 'src/components/common/loading/Loading';
import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

export const ViewCollectionEntryDetailsModal = ({
  collectionId,
  collectionEntryId,
  isOpen,
  onClose,
}: {
  collectionId: string;
  collectionEntryId: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { data, loading } = useQuery<
    GraphQLTypes.ViewCollectionDetailsModal,
    GraphQLTypes.ViewCollectionDetailsModalVariables
  >(
    gql`
      query ViewCollectionDetailsModal(
        $collectionId: ID!
        $collectionEntryId: ID!
      ) {
        operationCollection(id: $collectionId) {
          ... on OperationCollection {
            id
            isShared
            isSandbox
            operation(id: $collectionEntryId) {
              ... on OperationCollectionEntry {
                id
                name
                createdAt
                createdBy {
                  id
                  ... on User {
                    fullName
                  }
                }
                lastUpdatedAt
                lastUpdatedBy {
                  id
                  ... on User {
                    fullName
                  }
                }
              }
            }
          }
        }
      }
    `,
    { variables: { collectionId, collectionEntryId } },
  );
  const collection =
    data?.operationCollection.__typename === 'OperationCollection'
      ? data.operationCollection
      : undefined;
  const collectionEntry =
    collection?.operation?.__typename === 'OperationCollectionEntry'
      ? collection.operation
      : undefined;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Details</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {loading ? (
            <Loading />
          ) : !collectionEntry ? (
            <div>Could not fetch details for operation</div>
          ) : (
            <>
              <div>
                <div className="font-semibold">Operation Name</div>
                <div className="break-words">{collectionEntry.name}</div>
              </div>
              {collectionEntry.createdBy?.__typename === 'User' && (
                <div>
                  <div className="font-semibold">Created By</div>
                  <div>{collectionEntry.createdBy.fullName}</div>
                </div>
              )}
              <div>
                <div className="font-semibold">Created At</div>
                <LocalTimestamp value={collectionEntry.createdAt} />
              </div>
              <div>
                <div className="font-semibold">Collection ID</div>
                <div className="break-words">{collection?.id}</div>
              </div>
              <div>
                <div className="font-semibold">Operation ID</div>
                <div className="break-words">{collectionEntry.id}</div>
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={onClose} type="button">
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
